<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('bankProfile.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('bankProfile.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div>
            <ts-button color="info" outline @click="addNew">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div>
            <div class="d-flex justify-content-between">
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 250px"
                class="inline-block"
              />
            </div>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="ts-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-nowrap">
              {{ record.bank_name }}
            </td>
            <td class="text-center ts-space-x-3 ts-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-full ts-mx-auto detail">
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.accountNumber') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.accountName') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('bankProfile.swiftCode') }}
                  </th>
                  <th class="ts-pl-2">
                    {{ $t('bankProfile.remark') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="ts-border-b-2"
                  v-for="(detail, index) in prop.record.bank_accounts"
                  :key="index"
                >
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.account_number }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.account_name }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.swift_code }}
                  </td>
                  <td class="ts-p-2 ts-whitespace-nowrap">
                    {{ detail.remarks }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('bankProfile.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      width="900px"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form.vue'
import { Errors } from 'form-backend-validation'

export default {
  name: 'bankProfileIndex',
  components: {
    FromAction
  },
  data () {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('bankProfile', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.bankProfile.search
      },
      set (newValue) {
        this.$store.commit('bankProfile/SET_SEARCH', newValue)
        this.$store.commit('bankProfile/RESET_CURRENT_PAGE')
      }
    },
    columns () {
      return [
        {
          name: this.$t('bankProfile.bankName'),
          style: 'white-space: nowrap;width:92%'
        },
        {
          name: this.$t('actions'),
          style: 'text-align:center; width: 1px;'
        }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('bankProfile/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$notify({ type: 'error', text: error.message })
        })
    },
    addNew () {
      this.showForm = true
    },
    edit (record) {
      this.$store.commit('bankProfile/SET_EDIT_DATA', record)
      this.showForm = true
    },
    clearEdit () {
      this.$store.commit('bankProfile/SET_EDIT_DATA', {})
      this.showForm = false
      this.fetchData()
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('bankProfile/destroy', record.bank_id)
        .then(response => {
          this.fetchData()
          this.$toasted.success(response.message)
          record._deleting = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('bankProfile/RESET_STATE')
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
